import {Column, Entity, ManyToOne, RelationId} from "typeorm";
import type {Relation} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Min} from "class-validator";
import {Competition} from ".";
import {Season} from "@/modules/season/entity";
import {Player} from "@/modules/team/entity";

@Entity()
export class CompetitionPlayerLog extends BaseEntity {
  @ManyToOne(() => Season)
  season: Relation<Season>;

  @RelationId((m: CompetitionPlayerLog) => m.player)
  playerId: number;

  @ManyToOne(() => Player)
  player: Relation<Player>;

  @ManyToOne(() => Competition)
  competition: Relation<Competition>;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  matches = 0;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  goals = 0;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  yellow = 0;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  yellowRed = 0;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  red = 0;
}
